const STORAGE_KEY_PREFIX = "onboarding-pending-photo";

export function getPendingPhotoStorageKey(userId: string): string {
  return `${STORAGE_KEY_PREFIX}-${userId}`;
}

export function savePendingPhotoUrl(userId: string, photoUrl: string): void {
  sessionStorage.setItem(getPendingPhotoStorageKey(userId), photoUrl);
}

export function loadPendingPhotoUrl(userId: string): string | null {
  return sessionStorage.getItem(getPendingPhotoStorageKey(userId));
}

export function clearPendingPhotoUrl(userId: string): void {
  sessionStorage.removeItem(getPendingPhotoStorageKey(userId));
}
